import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonCol, IonIcon, IonInput, IonLabel, IonNote, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea } from '@ionic/react';
import { addCircleOutline, locationOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';

interface PlaceCreateEmbedProps {
    placeTextRef: any;
    onPlaceNameChange?: (source: string, value: string) => void;
}

const PlaceCreateEmbed: React.FC<PlaceCreateEmbedProps> = ({placeTextRef, onPlaceNameChange}) => {  
    const [loading, setLoading] = useState<boolean>(true);  
    const [newPlaceDetailOpen, setNewPlaceDetailOpen] = useState<boolean>(false);
    const phoneInputRef = useRef<any>();
    
    const { limits, profiles, countries, getCountries } = useAppContext();
    
    useEffect(() => { 
        const effect = async () => {
            if(countries.length === 0) await getCountries(); 
            setLoading(false);
        }
        effect();
    }, []); 

    const togglePlaceDetailOpen = () => {
        setNewPlaceDetailOpen(!newPlaceDetailOpen);
    };

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue;
    };

    return (
        <>              
            {!loading && profiles?.places >= limits?.places &&
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                            You've reached the limit of Places for your current plan.
                        </IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <p className='ion-margin-bottom ion-text-center'>
                            You can add more Places by upgrading to a SoloWise Premium plan. 
                        </p>
                        <p className='ion-margin-bottom ion-text-center'>                            
                            <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                        </p>
                    </IonCardContent>
                </IonCard>
            } 

            {!loading && profiles?.places < limits?.places &&
            <>
                <IonRow className='ion-margin-bottom'>
                    <IonCol size='12'>
                        <IonLabel color={'dark'}><b>Name</b></IonLabel><br />
                        <IonNote><em>Home, Work, Some Trailhead, etc.</em></IonNote>
                    </IonCol>
                    <IonCol size='12'>
                        <IonInput 
                            autocapitalize='sentences' 
                            clearInput={true}
                            counter 
                            fill='outline' 
                            name='placeName' 
                            onIonInput={(e) => {
                                const value = e.detail.value ?? '';
                                //setPlaceName(value);
                                onPlaceNameChange?.('placeName', value);
                            }} 
                            placeholder='' 
                            type='text' 
                            maxlength={50}
                            ref={placeTextRef}></IonInput>                                        
                    </IonCol>                                  
                </IonRow>

                <IonRow className='ion-margin-bottom'>
                    <IonCol>
                        <IonText className='link' color={'secondary'} onClick={togglePlaceDetailOpen}>
                                {newPlaceDetailOpen ? '- Remove' : '+ Add'} Optional Place Details
                        </IonText>
                    </IonCol>
                </IonRow>
                
                {newPlaceDetailOpen &&
                  <>
                    <IonRow className='ion-margin-bottom'>
                        <IonCol size='12'>
                            <IonLabel color={'dark'}><b>Address / Location</b></IonLabel><br />
                            <IonNote><em>Street address, GPS coordinates, or just a good description</em></IonNote>
                        </IonCol>
                        <IonCol size='12'>
                            <IonTextarea autocapitalize='sentences' autoGrow={true} fill='outline' name='placeLocation' placeholder=''></IonTextarea>                               
                        </IonCol>
                    </IonRow>

                    <IonRow className='ion-margin-bottom'>
                        <IonCol size='12'>
                            <IonLabel color={'dark'}><b>Google Maps Link</b></IonLabel>
                        </IonCol>
                        <IonCol size='12'>
                            <IonTextarea autoGrow={true} fill='outline' name='placeMapLink' placeholder=''></IonTextarea>                              
                        </IonCol>
                    </IonRow>

                    <IonRow className='ion-margin-bottom'>
                        <IonCol size='12'>
                            <IonLabel color={'dark'}><b>Landline Phone</b></IonLabel>
                        </IonCol>
                        <IonCol sizeXs='12' sizeSm='6'>
                            <IonSelect fill='outline' label='Country Code' labelPlacement='stacked' name='placePhoneCode' placeholder='Country Code' value={'+1'}>
                                <IonSelectOption value='+1'>+1 (United States / Canada)</IonSelectOption>
                                {countries.map((country:any, index:number) => (
                                    <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                                ))}
                            </IonSelect>
                        </IonCol>
                        <IonCol sizeXs='12' sizeSm='6'>
                            <IonInput fill='outline' label='Phone Number' labelPlacement='stacked' name='placePhone' onKeyUp={formatPhone} ref={phoneInputRef} type='tel'></IonInput>  
                        </IonCol> 
                    </IonRow>
                  </>
                }

                <hr />
                
                {profiles?.places < limits?.places && 
                <IonRow className='ion-margin-bottom'>
                    <IonCol>
                        <IonCheckbox color={'secondary'} labelPlacement="end" name='savePlace'>Save this Place</IonCheckbox>
                    </IonCol>
                </IonRow>
                }  
            </>                    
            }          
        </>
    );
};

export default PlaceCreateEmbed;